//frontend/src/components/Chat/ChatRoom.jsx непосредственно содержимое открытого чата

import React, { useMemo } from "react";

import MessageList from "./MessageList";
import MessageInput from "./MessageInput";

import useMatrixMessages from "../hooks/useMatrixMessages";

import "./ChatRoom.css";


function getRoomName(room, client) {
  if (!room) {
    return "Чат";
  }

  if (room.name) {
    return room.name;
  }

  const canonicalAlias =
    room.getCanonicalAlias?.();

  if (canonicalAlias) {
    return canonicalAlias;
  }

  const defaultName =
    room.getDefaultRoomName?.(
      client?.getUserId?.()
    );

  if (defaultName) {
    return defaultName;
  }

  return room.roomId || "Чат";
}


function getRoomInitial(roomName) {
  if (!roomName) {
    return "?";
  }

  return roomName
    .trim()
    .charAt(0)
    .toUpperCase();
}


function getRoomAvatarUrl(room, client) {
  if (!room || !client) {
    return "";
  }

  try {
    const baseUrl =
      client.getHomeserverUrl?.();

    if (!baseUrl) {
      return "";
    }

    return (
      room.getAvatarUrl?.(
        baseUrl,
        64,
        64,
        "crop",
        true,
        false
      ) || ""
    );
  } catch (error) {
    console.error(
      "[CHAT] Ошибка получения аватара комнаты:",
      error
    );

    return "";
  }
}


export default function ChatRoom({
  roomId,
  client,
}) {
  const {
    room,
    messages,
    loadingOlder,
    hasOlderMessages,
    loadOlderMessages,
  } = useMatrixMessages(
    client,
    roomId
  );


  const roomName = useMemo(
    () =>
      getRoomName(
        room,
        client
      ),
    [room, client]
  );


  const roomInitial =
    getRoomInitial(roomName);


  const avatarUrl =
    getRoomAvatarUrl(
      room,
      client
    );


  if (!roomId) {
    return (
      <section className="chat-room chat-room--empty">

        <div className="chat-room__empty">

          <div className="chat-room__empty-icon">
            💬
          </div>

          <h2>
            Выберите чат
          </h2>

          <p>
            Выберите комнату слева,
            чтобы открыть переписку
          </p>

        </div>

      </section>
    );
  }


  if (!room) {
    return (
      <section className="chat-room chat-room--empty">

        <div className="chat-room__empty">

          <div className="chat-room__empty-icon">
            ⚠️
          </div>

          <h2>
            Комната не найдена
          </h2>

          <p>
            Matrix не загрузил
            выбранную комнату
          </p>

        </div>

      </section>
    );
  }


  return (
    <section className="chat-room">

      <header className="chat-room__header">

        <div className="chat-room__identity">

          {avatarUrl ? (

            <img
              className="chat-room__avatar chat-room__avatar--image"
              src={avatarUrl}
              alt={roomName}
            />

          ) : (

            <div className="chat-room__avatar">
              {roomInitial}
            </div>

          )}


          <div className="chat-room__header-info">

            <h2 title={roomName}>
              {roomName}
            </h2>

          </div>

        </div>

      </header>


      <MessageList
        messages={messages}
        client={client}
        room={room}
        loadingOlder={loadingOlder}
        hasOlderMessages={
          hasOlderMessages
        }
        loadOlderMessages={
          loadOlderMessages
        }
      />


      <div className="chat-room__input">

        <MessageInput
          roomId={roomId}
          client={client}
        />

      </div>

    </section>
  );
}